export default function secondsToHuman (seconds) {
    let dateObj = new Date(seconds * 1000)

    let hours = dateObj.getUTCHours()
    let minutes = dateObj.getUTCMinutes()

    return `${hours ? `${hours}h` : ``} ${minutes}m`
}
